export default {
  metaInfo: {
    title: "회원가입 완료",
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
};
